const arrangeEventsByDate = (events) => {
    const arrangedEvents = events.sort((a, b) =>
        a.eventDate > b.eventDate ? 1 : b.eventDate > a.eventDate ? -1 : 0
    );
    return arrangedEvents
}
export default arrangeEventsByDate;